import { Card, Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import Menu from './master/menu';
import { Meta } from 'antd/es/list/Item';

const menuItems = [
  { title: "Templates", path: "/templates" },
  { title: "Work Orders", path: "/workorders" },
  { title: "Account", path: "/account" }
];

export default function () {
  const navigate = useNavigate();

  function onCardClicked(path: string) {
    navigate(path);
  };

  return (
    <Menu>
      <Row gutter={[16, 24]} justify="center">
        {menuItems.map(menuItem => (
          <Col xs={24} sm={12} md={8} lg={6} key={menuItem.title}>
            <Card
              hoverable
              onClick={() => onCardClicked(menuItem.path)}
              style={{ textAlign: 'center', cursor: 'pointer', transition: 'transform 0.2s' }}
            >
              <Meta title={menuItem.title} style={{ textAlign: 'center' }} />
            </Card>
          </Col>
        ))}
      </Row>
    </Menu>
  );
}